import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TableDraggable from './TableDraggable'
import Paper from '@material-ui/core/Paper'
const propTypes = {
  tables: PropTypes.array.isRequired,
  map: PropTypes.object.isRequired,
  size: PropTypes.string.isRequired,
  updateTable: PropTypes.func,
  editTable: PropTypes.func,
  deleteTable: PropTypes.func,
  updateMapSize: PropTypes.func,
  toggled: PropTypes.bool,
  selectTable: PropTypes.func,
  isSelectable: PropTypes.bool,
  selectedTable: PropTypes.string
}

class PlanComponent extends Component {
  render() {
    const {
      tables,
      updateTable,
      editTable,
      deleteTable,
      toggled,
      map,
      updateMapSize,
      size,
      isSelectable,
      selectedTable,
      selectTable
    } = this.props
    const style = {
      width: map.width,
      height: map.height
      // top: map.minY,
      // left: map.minX,
      // marginTop: -map.minY + 'px',
      // marginLeft: -map.minX + 'px',
      // paddingTop: -map.minY + 'px',
      // paddingLeft: -map.minX + 'px'
    }
    switch (size) {
      case 'small':
        style.width = map.width / 2
        style.height = map.height / 2
        break
      default:
        style.width = map.width
        style.height = map.height
    }
    const planContainerClass = 'planContainer ' + size
    return (
      <Paper elevation={3} className={planContainerClass} style={style}>
        {tables.map((table, index) => {
          return (
            <TableDraggable
              isSelectable={isSelectable}
              selectedTable={selectedTable}
              selectTable={selectTable}
              table={table}
              key={index}
              sizeClass={size}
              deleteTable={deleteTable}
              updateTable={updateTable}
              editTable={editTable}
              updateMapSize={updateMapSize}
              toggled={toggled}
            />
          )
        })}
      </Paper>
    )
  }
}

PlanComponent.propTypes = propTypes
PlanComponent.defaultProps = {
  updateTable: function() {},
  deleteTable: function() {},
  updateMapSize: function() {},
  selectTable: function() {},
  editTable: function() {},
  isSelectable: false,
  selectedTable: 'none'
}
export default PlanComponent



// WEBPACK FOOTER //
// ./src/routes/Admin/Tables/components/PlanComponent.js